$(document).ready(function () {
  $('#contactFormSubject').focus(function () {
    $('.collapse').toggle(200);
  });

  $('.level-1').click(function () {
    let title_level_1 = $(this).data('title');
    let level_2_el = $('.level-2[data-title="' + title_level_1 + '"]');
    if (level_2_el.length) {
      if (!level_2_el.is(":visible")) {
        level_2_el.show(200);
      } else {
        level_2_el.hide(200);
      }
    } else {
      $('#contactFormSubject').val(title_level_1.trim());
      $('.collapse').hide(200);
    }

    // Check required to attach images
    if ($(this).data('required-attach-images')) {
      $('input[name^="contact[file]"]').prop('required',true);
    } else {
      $('input[name^="contact[file]"]').prop('required',false);
    }
  });

  $('.level-2').click(function () {
    $('#contactFormSubject').val($(this).text().trim());
    $('.collapse').hide(200);

    // Check required to attach images
    if ($(this).data('required-attach-images')) {
      $('input[name^="contact[file]"]').prop('required',true);
    } else {
      $('input[name^="contact[file]"]').prop('required',false);
    }
  });

  $('input[name^="contact[file]"]').on('change', function () {
    var el = $(this);
    var el_progressbar = $('.progress .bar');
    var el_input_submit = $('.contact-form input[type=submit]');
    var el_attach_images = $('input[name^="contact[attach_images]"]');
    var formData = new FormData();
    var totalFiles = $(this)[0].files.length;
    for (var i = 0; i < totalFiles; i++) {
      formData.append("files[]", $(this)[0].files[i]);
    }

    $.ajax({
      url: 'https://api.succulentsbox.com/api/upload-images',
      type: 'post',
      data: formData,
      contentType: false,
      processData: false,
      beforeSend: function () {
        el_input_submit.prop('disabled', true);
        el_progressbar.text('0% uploading...');
        el_progressbar.css('width', '1%');
        el_progressbar.css('background-image', 'linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)');
        $('.progress').show();
      },
      xhr: function () {
        var xhr = $.ajaxSettings.xhr();
        if (xhr.upload) {
          xhr.upload.addEventListener('progress', function (event) {
            var percent = 0;
            var position = event.loaded || event.position;
            var total = event.total;
            if (event.lengthComputable) {
              percent = Math.ceil(position / total * 100);
            }
            // Update progressbar
            el_progressbar.css('width', percent + '%');
            el_progressbar.text(percent + '% uploading...');
          }, true);
        }
        return xhr;
      },
      success: function (res) {
        el_progressbar.text('Upload successful!');
        el_progressbar.css('background-image', 'none');
        el_input_submit.prop('disabled', false);
        $('.preview').show();
        if (res.result) {
          var stringUrl = '';
          for (var i = 0; i < res.result.length; i++) {
            $('.preview .img-hidden').append('<img src="' + res.result[i] + '">');
            if (res.result.length == parseInt(i) + 1) {
              stringUrl += '* ' + res.result[i];
            } else {
              stringUrl += '* ' + res.result[i] + '\n\n';
            }
          }

          var stringUrlGrid = [];
          $('.preview .img-hidden img').each(function () {
            stringUrlGrid.push($(this).attr('src'));
          });
          $('.preview .img').imagesGrid({
            images: stringUrlGrid
          });

          var attach_images_val = el_attach_images.val();
          if (attach_images_val) {
            el_attach_images.val(attach_images_val + '\n\n' + stringUrl);
          } else {
            el_attach_images.val(stringUrl);
          }

          el.val('');
        }
      }
    });
  });

  $('.preview .remove').click(function () {
    $('input[name^="contact[attach_images]"]').val('');
    $('.preview .img').html('');
    $('.preview .img-hidden').html('');
    $('.preview').hide();
    $('.progress').hide();
  });
});